'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n'], ['\n  display: block;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledSVG = _styledComponents2.default.svg(_templateObject);

/**
# YellowLineSVG
An SVG yellow line intended to emphasize some copy
 */
var YellowLineSVG = function YellowLineSVG() {
  return _react2.default.createElement(
    StyledSVG,
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 43 3',
      'aria-label': 'Yellow Line',
      role: 'img',
      width: '43px',
      height: '3px'
    },
    _react2.default.createElement(
      'title',
      null,
      'Yellow Line'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'An SVG yellow line intended to emphasize some copy'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        strokeLinecap: 'square'
      },
      _react2.default.createElement('path', {
        d: 'M1.5,1.5 L41.5,1.5',
        stroke: '#FFBB2B',
        strokeWidth: '3'
      })
    )
  );
};

YellowLineSVG.displayName = 'YellowLineSVG';

exports.default = YellowLineSVG;
YellowLineSVG.__docgenInfo = {
  'description': '# YellowLineSVG\r\nAn SVG yellow line intended to emphasize some copy',
  'methods': [],
  'displayName': 'YellowLineSVG'
};